import { Typography } from "@mui/material";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import AutoHelp from "../../../../UI/Wrappers/AutoHelp";
import { safeJSONParse } from "../../../Actions/utils";

const UIText = {
  "es-CL": { from: "De: ", to: "Para: " },
  "en-US": { from: "From: ", to: "To: " },
};

const Sender = ({ fontSize, fromM, toRecipients }) => {
  const { settings } = useUIBp();
  const { from, to } = UIText[settings.locale];
  const emailFrom = safeJSONParse(fromM);
  const emailTo = safeJSONParse(toRecipients, []);

  let text = "";
  let fixedTooltip = "";
  if (emailFrom?.emailAddress) {
    const ea = emailFrom.emailAddress;
    text = `${from} ${ea.name ?? ea.address ?? ""}`;
    fixedTooltip = `(${ea.name ?? ""}) ${ea.address ?? ""}`;
  } else if (Array.isArray(emailTo) && emailTo.length) {
    text = `${to}`;
    let first = true;
    for (const m of emailTo) {
      const ea = m?.emailAddress ?? {};
      if (first) {
        first = false;
      } else {
        text = `${text}, `;
        fixedTooltip = `${fixedTooltip}, `;
      }
      text = `${text}${ea.name ?? ea.address ?? ""}`;
      fixedTooltip = `${fixedTooltip}(${ea.name ?? ""}) ${ea.address ?? ""}`;
    }
  }

  return (
    <AutoHelp {...{ fixedTooltip }}>
      <Typography noWrap {...{ fontSize, sx: { cursor: "default" } }}>
        {text}
      </Typography>
    </AutoHelp>
  );
};

export default Sender;
